export default function SendIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="send">
        <mask
          id="mask0_353_197"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_353_197)">
          <path
            id="send_2"
            d="M3 20V14L11 12L3 10V4L22 12L3 20Z"
            fill="#004334"
          />
        </g>
      </g>
    </svg>
  );
}
